import { MAILING_DOUBLE_OPT_IN_SETTINGS_API } from 'modules/profile/mailing-settings/api/mailing-settings-double-opt-in-api'
import { MailingDoubleOptInSettingsInterface } from 'modules/profile/mailing-settings/types/mailing-settings-double-optin-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useOnceTrue } from 'shared/hooks/use-once-true'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

interface useMailingDoubleOptInInterface {
  shouldFetch: boolean
}

export function useMailingDoubleOptIn({ shouldFetch }: useMailingDoubleOptInInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, any>({
    method: RequestMethodsEnum.get,
  })

  const allowed = useOnceTrue(!!user && !!shouldFetch)

  const { data: mailingDoubleOptInSettings, mutate: mutateOptInSettings } =
    useSWR<MailingDoubleOptInSettingsInterface>(() => {
      if (allowed) {
        return MAILING_DOUBLE_OPT_IN_SETTINGS_API
      }
      return null
    }, fetcher)

  return {
    mailingDoubleOptInSettings,
    mutateOptInSettings,
  }
}
